import { getQueryString } from 'utility/helpers';
import { globalEndpoints } from './global';

export const toolsEndpoints = {
  getHsmvDemoCheck: (params) => {
    const queryString = getQueryString(params);
    return `${globalEndpoints.apiUrl}/Tools/HsmvDemographics?${queryString}`;
  },

  getHsmvPhotoCheck: (params) => {
    const queryString = getQueryString(params);
    return `${globalEndpoints.apiUrl}/Tools/HsmvPhoto?${queryString}`;
  },

  getSystemInformation: () => {
    return `${globalEndpoints.apiUrl}/Tools/ServerInformation`;
  }
};
